const state = {
    product: null,
    variant: null,
};

const getters = {
    product: state => state.product,
    variant: state => state.variant,
};

const mutations = {
    setProduct: (state, data) => state.product = data,
    setVariant: (state, data) => state.variant = data,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    strict: false
};